<script>
    import Navbar from "../widget/Navbar.svelte";
    import Footer from "../widget/Footer.svelte";
    import { Link } from "svelte-routing";
</script>
<Navbar/>

<div class="container">
	<div class="row">
	<div class="col-12 col-md-5 p-3 text-center">
		<h1>About this app</h1>
<img class="img-fluid rounded-circle" src="https://1.bp.blogspot.com/-1SsK6GHeVyY/YY6VxiYCiXI/AAAAAAAAR10/s7JSkHIyiSY2SJabqceTpZeY6F6n0bh9gCLcBGAsYHQ/s400/sveltes.png" alt="SvelteKit unicenta web apps" />
</div>	
<div class="col-12 col-md-7 p-3">
<p>
		This is web apps is generated by <a class="text-secondary" href="https://kit.svelte.dev" target="_blank">SvelteKit</a>. You can make your own by typing the
		following into your command line and following the prompts:
	</p>

	<!-- TODO lose the @next! -->
	<pre>npm init svelte@next</pre>

	<p>
		An open source code for unicenta website application dashboard, so you can use this web apps for monitoring your unicenta desktop version, using API for integration with unincenta desktop databased.
	</p>

	<p>
		For using this apps, for first <a href="https://unicenta.com/download-files/" target="_blank" class="text-secondary">download unicenta pos dekstop version </a> , and download this source code install using node , then you need to integration API databased. cloud your web app, and viola... now you can work with this web apps.
	</p>
	<p>Build your modern website and integration with unicenta opos desktop apps now <br/><br/><Link to="/webapp" class="border border-secondary text-secondary p-1">Unicenta Web Apps →</Link></p>
</div></div></div>
<Footer/>